/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Measure_Unit_Audio_Minute_OneInputs */

const en_measure_unit_audio_minute_one = /** @type {(inputs: Measure_Unit_Audio_Minute_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} audio minute`)
};

const zh_hans1_measure_unit_audio_minute_one = /** @type {(inputs: Measure_Unit_Audio_Minute_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 分钟音频`)
};

const pt_br2_measure_unit_audio_minute_one = /** @type {(inputs: Measure_Unit_Audio_Minute_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} minuto de áudio`)
};

const es_measure_unit_audio_minute_one = /** @type {(inputs: Measure_Unit_Audio_Minute_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} minuto de audio`)
};

const fr_measure_unit_audio_minute_one = /** @type {(inputs: Measure_Unit_Audio_Minute_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} minute audio`)
};

const de_measure_unit_audio_minute_one = /** @type {(inputs: Measure_Unit_Audio_Minute_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Audiominute`)
};

const ru_measure_unit_audio_minute_one = /** @type {(inputs: Measure_Unit_Audio_Minute_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} минута аудио`)
};

const it_measure_unit_audio_minute_one = /** @type {(inputs: Measure_Unit_Audio_Minute_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} minuto di audio`)
};

/**
* | output |
* | --- |
* | "{count} audio minute" |
*
* @param {Measure_Unit_Audio_Minute_OneInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_unit_audio_minute_one = /** @type {((inputs: Measure_Unit_Audio_Minute_OneInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Unit_Audio_Minute_OneInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_unit_audio_minute_one(inputs)
	if (locale === "pt-BR") return pt_br2_measure_unit_audio_minute_one(inputs)
	if (locale === "es") return es_measure_unit_audio_minute_one(inputs)
	if (locale === "fr") return fr_measure_unit_audio_minute_one(inputs)
	if (locale === "de") return de_measure_unit_audio_minute_one(inputs)
	if (locale === "ru") return ru_measure_unit_audio_minute_one(inputs)
	if (locale === "it") return it_measure_unit_audio_minute_one(inputs)
	return en_measure_unit_audio_minute_one(inputs)
});